type ConfirmCallback = (args?: unknown) => void | Promise<void>;

let pendingConfirmCallback: ConfirmCallback | null = null;

export const registerConfirmCallback = (callback: ConfirmCallback) => {
  pendingConfirmCallback = callback;
};

export const executeConfirmCallback = async (args?: unknown) => {
  const callback = pendingConfirmCallback;
  pendingConfirmCallback = null;
  await callback?.(args);
};

export const clearConfirmCallback = () => {
  pendingConfirmCallback = null;
};
